import jeffreyPic from "@/public/images/artists/jeffrey.png";
import { Artist } from "@/types/types";

export const jeffrey = {
  id: "232",
  name: "Jeffrey",
  image: jeffreyPic,
  description: `Jeffrey's voice is bold and commanding, with a deep, raspy tone perfect for energetic, rhythm-driven beats.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjeffrey-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop", "Spoken Word", "Deep", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 43,
        high: 63,
      },
      sweetSpot: 50,
    },
  },
} as const satisfies Artist;
